import difference from 'lodash/difference';
import union from 'lodash/union';
import { t as reportsTableActionTypes } from 'modules/reportsTable';
import { t as entityActionTypes } from 'modules/reportDataSourceTable';
import {
  FETCH_REPORT_MODAL_TABLE_DATA_RESPONSE,
  REMOVE_REPORTING_TYPE_MODAL_ID,
  ADD_REPORTING_TYPE_MODAL_ID,
  UPDATE_REPORTING_TYPE_IDS,
  CLEAR_REPORTING_TYPE_MODAL_IDS,
  FETCH_REPORT_BY_ID_RESPONSE,
  INITIALIZE_SELECTED_TYPE_IDS,
  UPDATE_REPORT_MODAL_TABLE_DATA,
  FETCH_UPDATE_REPORT_MODAL_TABLE_DATA_RESPONSE,
  FETCH_REPORT_MODAL_TABLE_DATA_REQUEST,
} from './actionTypes';

const initialState = {
  isLoading: false,
  tableConfig: {
    page: 1,
    pageSize: 10,
    orderBy: 'id',
    sortDesc: true,
    sorting: 'descending',
    filter: '',
  },
  selectedTypeIdsInModal: [],
  selectedTypeIds: {},
};

const reducer = (state = initialState, action) => {
  const selectedTypeIdsInModal = state.selectedTypeIdsInModal
    ? state.selectedTypeIdsInModal.slice(0)
    : [];
  switch (action.type) {
    case FETCH_REPORT_MODAL_TABLE_DATA_REQUEST:
      return {
        ...state,
        tableConfig: initialState.tableConfig,
        isLoading: true,
      };
    case FETCH_REPORT_MODAL_TABLE_DATA_RESPONSE:
      return {
        ...state,
        reportingEntities: action.results,
        reportingEntitiesTotal: action.total,
        selectedTypeIdsInModal:
          (action.selectedTypeIds
            ? state.selectedTypeIds[action.componentType]
            : action.selectedTypeIdsInModal) || [],
        componentType: action.componentType,
        isLoading: false,
      };
    case FETCH_UPDATE_REPORT_MODAL_TABLE_DATA_RESPONSE:
      return {
        ...state,
        reportingEntities: action.results,
        reportingEntitiesTotal: action.total,
        selectedTypeIdsInModal: action.selectedTypeIdsInModal,
      };
    case REMOVE_REPORTING_TYPE_MODAL_ID:
      return {
        ...state,
        selectedTypeIdsInModal: state.selectedTypeIdsInModal.filter((id) => action.id !== id),
      };
    case ADD_REPORTING_TYPE_MODAL_ID:
      return {
        ...state,
        selectedTypeIdsInModal: [...state.selectedTypeIdsInModal, action.id],
      };
    case UPDATE_REPORTING_TYPE_IDS:
      return {
        ...state,
        selectedTypeIds: {
          [action.componentType]: selectedTypeIdsInModal,
        },
        selectedTypeIdsInModal: [],
      };
    case FETCH_REPORT_BY_ID_RESPONSE:
    case INITIALIZE_SELECTED_TYPE_IDS:
      return {
        ...state,
        selectedTypeIds: {
          [action.report.componentType]: action.report.componentIds,
        },
      };
    case CLEAR_REPORTING_TYPE_MODAL_IDS:
    case reportsTableActionTypes.REPORT_CREATED:
      return {
        ...state,
        selectedTypeIdsInModal: [],
        tableConfig: initialState.tableConfig,
      };
    case UPDATE_REPORT_MODAL_TABLE_DATA:
      return {
        ...state,
        tableConfig: action.config,
      };
    case entityActionTypes.SELECT_ALL_ENTITIES:
      return {
        ...state,
        selectedTypeIdsInModal: union(state.selectedTypeIdsInModal, action.ids),
      };
    case entityActionTypes.DESELECT_ALL_ENTITIES:
      return {
        ...state,
        selectedTypeIdsInModal: difference(state.selectedTypeIdsInModal, action.ids),
      };
    case entityActionTypes.REMOVE_ENTITY:
      return {
        ...state,
        selectedTypeIdsInModal: difference(state.selectedTypeIdsInModal, [action.id]),
      };
    default:
      return state;
  }
};

export default reducer;
